export const ModalNames = {
  SlAccountsAddAndEdit: 'slAccountsAddAndEdit',
  SlAccountsDelete: 'slAccountsDelete',
};

export const AlertMessages = {
  SlGlJournalExists: 'Selected row cannot be deleted because the SL Account is used in a GL Journal definition for this period.',
  LifecycleExists: 'Selected row cannot be deleted because the SL Account is used in a SL Account lifecycle map for this period.',
};

export const LIFECYCLE_REGEXP = /^LIFE.*/;

export const SL_ACCOUNT_INDEX_KEYS = ['slAccount'];
